import * as React from "react";
const SvgCheckboxUnticked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 3.5, stroke: "#2196F3" }));
export default SvgCheckboxUnticked;
